module.exports = __webpack_public_path__ + "static/media/terms.1498b27c.jpg";